import Navigator from 'app';
import BillCollection from '../bill/bill_collection';
import MemberCommitteeCollection from './member_committee_collection';
import MemberVoteCollection from './member_vote_collection';
import MemberContributorCollection from './member_contributor_collection';
import MemberDistrictModel from './member_district_model';
const MemberModel = Backbone.Model.extend({
  urlRoot: Navigator.config.api_base + 'members/',
  parse: function memberParse(response) {
    var data = response;
    console.log("EMD DATA: ", data);
    if (response.bills) {
      data.bills = new BillCollection(response.bills);
    }
    if (response.member_committees) {
      data.member_committees = new MemberCommitteeCollection(response.member_committees);
    }
    if (response.member_votes) {
      data.member_votes = new MemberVoteCollection(response.member_votes);
    }
    if (response.top_contributors) {
      data.top_contributors = new MemberContributorCollection(response.top_contributors);
    }
    if (response.district) {
      data.district = new MemberDistrictModel(response.district);
    }
    return data;
  },
  initialize: function (id) {
    // Create tooltip info string
    let distCity = this.get("district_address_city");
    distCity ? distCity = `, ${distCity}` : '';
    let tooltipInfo = `${this.get("full_name")} ${distCity ? distCity : ''}`;
    if (this.get("title") !== null) {
      tooltipInfo += ", " + this.get("title");
    }
    this.set("tooltip_info", tooltipInfo);
  }
});
const API = {
  getMember: function getMember(memberId) {
    var defer = $.Deferred();
    var member = new MemberModel({
      id: memberId
    });
    member.fetch({
      dataType: "json",
      success: function (data) {
        defer.resolve(data);
      },
      error: function () {
        defer.reject('Could not fetch data for member ' + memberId);
      }
    });
    return defer.promise();
  }
};
Navigator.reqres.setHandler("member:detail", function (id) {
  return API.getMember(id);
});
export { MemberModel as default };